var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 412,
    viewBox: "0 0 179 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166 0.5C158.5 75.5 9.30008 104.3 22.5001 181.5C39.0001 278 165 216.5 140.5 157C116 97.5 -3.49994 181.5 2.00008 253C7.50009 324.5 64.5 330.5 115.5 351.5C166.5 372.5 164.5 391 178 411",
    stroke: "url(#paint0_linear_54_6839)",
    strokeWidth: 2,
    strokeDasharray: "20 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_6839",
    x1: 151,
    y1: -5.08252e-7,
    x2: 135,
    y2: 534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2E2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightLine);
export default __webpack_public_path__ + "static/media/flight-line.996d0a2536cd297459377a19532b316c.svg";
export { ForwardRef as ReactComponent };